// extracted by mini-css-extract-plugin
export var active = "PaginatedCollection-module--active--0b1a6";
export var buttonClean = "PaginatedCollection-module--buttonClean--c5c50";
export var entriesGroup = "PaginatedCollection-module--entriesGroup--1ec92";
export var icon = "PaginatedCollection-module--icon--1b507";
export var pagination = "PaginatedCollection-module--pagination--c1e22";
export var prevBtnRotate = "PaginatedCollection-module--prevBtnRotate--a5079";